import { isPlatformBrowser } from "@angular/common";
import {
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
    Inject,
    Input,
    OnInit,
    PLATFORM_ID,
    signal,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ParamFilters } from "@app/models/filtermodels/ParamFilters";
import { HotelFiltersService } from "@app/services/hotelfilters.service";

@Component({
    selector: "clever-category",
    templateUrl: "./category.component.html",
    styleUrls: ["./category.component.scss"],
    standalone: false,
})
export class CategoryComponent implements OnInit {
    @Input() mode: string;
    isBrowser = signal<boolean>(false);
    selectedCat = signal<number>(0);
    tmparr: number[] = [1, 2, 3, 4, 5];
    destroyRef = inject(DestroyRef);

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            this.initFilterSub();
        }
    }

    select(k) {
        this.selectedCat.set(k);
        this.hotelService.category(this.selectedCat(), true);
        // console.log(this.selectedCat());
        // this.cdr.detectChanges();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((filter: ParamFilters) => {
                this.selectedCat.set(filter?.minCategory);
            });
    }
}
